export enum PlaceholdersListEnum {
    TaggedUser = 1,
    ShareUser = 2,
    SharePatient = 3
}
